import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Landing from './components/Landing';
import Footer from './components/Footer';

function App() {
  return (
    <Router>
      <div className="app">
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
        <div id="footer">
        <Footer />
        </div>
        
      </div>
    </Router>
  );
}

export default App;
